import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const liveGpsLocationEmbedDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.liveGps,
  componentType: LAYOUT_COMPONENT_TYPE.liveGpsLocationEmbed,
  registryBlockKey: REGISTRY_BLOCK.presentation.liveGpsLocationEmbed,
  displayOrder: 6,
  content: {
    sectionTitle: loc3('Live-Standort', 'Live location', 'Vị trí trực tiếp'),
    statusLabel: loc3('Jetzt geöffnet', 'Open now', 'Đang mở'),
    address: loc3(
      'Viktualienmarkt · Standfläche Süd',
      'Viktualienmarkt · South bay',
      'Viktualienmarkt · Khu phía nam',
    ),
    updatedAt: loc3('Aktualisiert vor 12 Min.', 'Updated 12 min ago', 'Cập nhật 12 phút trước'),
    mapEmbedUrl: loc3(
      'https://www.openstreetmap.org/export/embed.html?bbox=11.574%2C48.134%2C11.578%2C48.136&layer=mapnik',
      'https://www.openstreetmap.org/export/embed.html?bbox=11.574%2C48.134%2C11.578%2C48.136&layer=mapnik',
      'https://www.openstreetmap.org/export/embed.html?bbox=11.574%2C48.134%2C11.578%2C48.136&layer=mapnik',
    ),
  },
  media: {},
};
